<template>
	<div class="events grid">
		<div class="filter row">
			<div class="location">
				<input type="text" id="address" v-model="maps.address">
				<button @click="requestUserLocation"><i class="far fa-location"></i></button>
				<button class="mobile-filter-toggle" :class="{'bordered': activeFilters}" @click="toggleMobileFilter"><i class="fal fa-filter"></i></button>
			</div>

			<div class="filters">
				<span v-html="labels.filter"></span>

				<div class="toggles">
                    <trigger-popup :toggle-label="labels.radius">
                    	<ul v-if="!mobileFilterActive">
                            <li v-for="term in radii">
                                <div class="radio">
	                                <input name="radius" v-model="temp.radius" :id="'radius-'+term.value" type="radio" :value="term.value">
	                                <label class="custom-radio" :for="'radius-'+term.value"></label>
	                                {{term.label}}
                                </div>
                            </li>
                        </ul>
                    </trigger-popup>

                    <trigger-popup :toggle-label="labels.keyword" :active-filters="query.keyword.length > 0">
                    	<input type="text" name="keyword" :placeholder="labels.keywordPlaceholder" v-model="temp.keyword">
                    </trigger-popup>

                    <trigger-popup :toggle-label="labels.amenities" :active-filters="query.amenities.length > 0">
                    	<ul class="checkbox-wrapper">
                            <li v-for="term in amenities">
                                <input class="custom-checkbox" name="amenities[]" v-model="temp.amenities" :id="'amenities-'+term.term_id" type="checkbox" :value="term.term_id">
                                <label :for="'amenities-'+term.term_id">{{term.name}}</label>

                            </li>
                        </ul>
                    </trigger-popup>

                    <trigger-popup :toggle-label="labels.type" :active-filters="query.types.length > 0">
                    	<ul class="checkbox-wrapper">
                            <li v-for="term in types">
                                <input class="custom-checkbox" name="types[]" v-model="temp.types" :id="'types-'+term.term_id" type="checkbox" :value="term.term_id">
                                <label :for="'types-'+term.term_id">{{term.name}}</label>

                            </li>
                        </ul>
                    </trigger-popup>
				</div>
			</div>
		</div>

		<mobile-filter v-if="mobileFilterActive" v-on:closeFilter="closeFilter" v-on:applyFilters="applyFilters">
			<label v-html="labels.radius"></label>
			<div class="options">
				<ul>
                    <li v-for="term in radii">
                        <div class="radio">
                            <input name="radius" v-model="temp.radius" :id="'radius-'+term.value" type="radio" :value="term.value">
                            <label class="custom-radio" :for="'radius-'+term.value">{{term.label}}</label>

                        </div>
                    </li>
                </ul>
            </div>

			<label v-html="labels.keyword"></label>
			<div class="options">
				<input type="text" name="keyword" :placeholder="labels.keywordPlaceholder" v-model="temp.keyword">
			</div>

			<label v-html="labels.amenities"></label>
			<div class="options">
				<ul class="checkbox-wrapper">
                    <li v-for="term in amenities">
                        <input class="custom-checkbox" name="amenities[]" v-model="temp.amenities" :id="'amenities-'+term.term_id" type="checkbox" :value="term.term_id">
                        <label :for="'amenities-'+term.term_id">{{term.name}}</label>

                    </li>
                </ul>
            </div>

            <label v-html="labels.type"></label>
			<div class="options">
				<ul class="checkbox-wrapper">
                    <li v-for="term in types">
                        <input class="custom-checkbox" name="types[]" v-model="temp.types" :id="'types-'+term.term_id" type="checkbox" :value="term.term_id">
                        <label :for="'types-'+term.term_id">{{term.name}}</label>

                    </li>
                </ul>
            </div>
		</mobile-filter>

		<div class="content row">
			<div class="results">
				<template v-if="results.posts.length">
					<h2 v-html="labels.eventResultsHeader"></h2>

					<div class="items">
						<div class="archive-item place" v-for="post in results.posts" :key="'post-'+post.id" @mouseenter="setHoverPin(post)" @mouseleave="setDefaultPin(post)">
							<div class="featured-image" v-if="post.featured_image_url">
								<a class="has-overlay" :href="post.permalink" target="_blank">
									<div class="image" :style="'background-image: url('+post.featured_image_url+')'">
										<div class="overlay">
											<i class="fal fa-chevron-circle-right"></i>
										</div>
									</div>
								</a>
							</div>
							<div class="content">
								<a :href="post.permalink" target="_blank"><h5 v-html="post.title"></h5></a>
								<p>
									<span class="location h6" v-html="post.meta.location"></span>
									<span class="status tag" v-html="formatKM(post.meta.distance)"></span><br/>

									<span class="description smaller">
										{{post.meta.date}}&nbsp;|&nbsp;{{post.meta.time}}
									</span><br/>

									<span class="edit-links smaller">
										<a v-html="labels.viewEvent" :href="post.permalink" target="_blank"></a>
									</span>
								</p>
							</div>
						</div>
					</div>

					<pagination :current="results.page" :last="results.maxPage" :total="results.total" :count="results.posts.length" v-on:loadPage="loadPage"></pagination>
				</template>

				<template v-else-if="loaded">
					<div class="no-results">
						<p v-html="labels.eventNoResults"></p>
					</div>
				</template>
			</div>

			<div id="map"></div>

			<div class="map-legend" v-if="affiliations && affiliations.length">
				<label v-html="labels.legend"></label>
				<ul>
					<li v-for="affiliation in affiliations" v-if="affiliation.term_id != default_affiliation">
						<div class="svg" v-html="affiliation.pinSvg"></div>

						<span v-html="affiliation.name"></span>
					</li>
				</ul>
			</div>

			<div class="inline-modal-overlay"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				namespace: '/wp-json/baytek/v1/event/search',
				results: {
                    loading: false,
                    posts: [],
                    total: 0,
                    page: 1,
                    maxPage: 0
                },
                query: {
                    paged: 1,
                    radius: -1,
                    keyword: '',
                    amenities: [],
                    types: [],
                    lat: '',
                    lng: ''
                },
                loaded: false,
                amenities: theme.prefiltered.amenities,
                types: theme.prefiltered.eventTypes,
                radii: [],
                temp: {
                	radius: -1,
                	keyword: '',
                	amenities: [],
                	types: []
                }
			}
		},

		computed: {
			activeFilters() {
				return this.query.keyword.length > 0 || this.query.amenities.length > 0 || this.query.types.length > 0;
			}
		},

		watch: {
			'maps.location'(val) {
				if (val.lat && val.lng) {
					this.query.lat = val.lat;
					this.query.lng = val.lng;

					this.filterEvents();
				}
			},

			'query.radius'() {
				this.filterEvents();
			},

			'query.keyword'() {
				this.filterEvents();
			},

			'query.amenities'() {
				this.filterEvents();
			},

			'query.types'() {
				this.filterEvents();
			},

			'query.paged'() {
				this.getEvents();
			},

			'results.posts'(val) {
				this.updateMap();
			}
		},

		created() {
			//Set values from localized data
			this.labels = theme.labels;
			this.radii = theme.radii;
			this.amenities = theme.amenities;
			this.types = theme.eventTypes;

			this.locateIP();
		},

		mounted() {
			this.handleFilterTriggers();
		},

		methods: {
			filterEvents() {
				if (this.updatingFilters) return;

                this.query.paged = 1;

                this.getEvents();
            },

			getEvents() {
				if (this.results.loading) return;
				this.results.loading = true;

				//Build request URL
				let url = `${this.namespace}?paged=${this.query.paged}&radius=${this.query.radius}&keyword=${this.query.keyword}&lat=${this.query.lat}&lng=${this.query.lng}&amenities=${this.query.amenities.join(',')}&types=${this.query.types.join(',')}&lang=${theme.lang}`;

				//Fetch the data
				this.getData(url)
	                .then(json => {
	                	if (json.posts) {
		                    this.results.posts = json.posts;
		                    this.results.page = json.page;
		                    this.results.maxPage = json.maxPage;
		                    this.results.total = json.total;
		                }
	                })
	                .finally(() => {
	                    if (this.loaded) this.scrollUp();

	                    this.results.loading = false;
	                    this.loaded = true;
	                });
			},

			getResults() {
				this.filterEvents();
			},

			setInfowindowContent(post) {
				//Open the content div
				let content = '<div class="infowindow-content">';

				//Put in the picture
				content += `<img src=${post.featured_image_url} class="featured-image">`;

				//Text area
				content += '<div class="content-area">';

				//Place title
				content += `<a href="${post.permalink}" target="_blank"><h5 class="item-title">${post.title}</h5></a>`;

				//Formatting paragraph
				content += '<p>';

				//Location
				content += `<span class="location h6">${post.meta.location}</span><br/>`;

				//Date/time
				content += `<span class="description smaller">${post.meta.date}&nbsp;|&nbsp;${post.meta.time}</span><br/>`

				//Open links
				content += '<span class="edit-links smaller">';

				//View place link
				content += `<a href="${post.permalink}" target="_blank">${this.labels.viewEvent}</a>`;

				//Close links
				content += '</span>';

				//Close the formatting paragraph
				content += '</p>';

				//Close the text area
				content += '</div>';

				//Close the content div
				content += '</div>';

				this.maps.infowindow.setContent(content);
			},
		},
	}
</script>
